import { component as defineComponent } from 'flightjs';

var metadataTags = function () {
    this.attributes({
        guaranteeTag: '[data-guarantee-tag]',
    });

    this.after('initialize', function () {
        this.on(document, 'dataContestActionSucceeded', this.updateTags);
    });

    this.updateTags = function (event, data) {
        var contest = data.contest;
        this.select('guaranteeTag').attr('data-disabled', !contest.isPrizeGuaranteed);
    };
};

export default defineComponent(metadataTags);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/contest-metadata.js